import { useCallback } from 'react'
import { useChainId, useAccount } from 'wagmi'

import { Hash } from 'types/entities'

import { useCheckAllowanceERC20, useApproveErc20Estimate } from 'hooks/token'

import { isEther } from 'utils/crypto'
import { errors } from 'constants/errors'
import { MAD_ASSEMBLY } from 'constants/addresses'
import { etherNumbers } from 'constants/variables'

import { ConfirmationStep } from './types'

export function useGetModalConfigurations() {
  const chainId = useChainId()
  const { address } = useAccount()

  const estimate = useApproveErc20Estimate()
  const checkAllowanceERC20 = useCheckAllowanceERC20()

  return useCallback(
    async (fromToken: Hash) => {
      let isRevokeRequired = false

      if (!address) {
        throw new Error(errors.wallet.WALLET_REQUIRED)
      }
      if (!isEther(fromToken)) {
        const [allowanceResult, estimateResult] = await Promise.allSettled([
          checkAllowanceERC20(address, fromToken, MAD_ASSEMBLY[chainId]),
          estimate(etherNumbers.MAX_UINT, fromToken, MAD_ASSEMBLY[chainId]),
        ])

        const allowance = allowanceResult.status === 'fulfilled' ? allowanceResult.value : null
        const isWithRevoke = estimateResult.status === 'rejected'

        isRevokeRequired = Boolean(isWithRevoke && allowance && allowance > etherNumbers.BG_ZERO)
      }

      const steps: ConfirmationStep[] = [ConfirmationStep.APPROVE]

      if (isRevokeRequired) {
        steps.unshift(ConfirmationStep.REVOKE)
      }

      return {
        steps,
        isRevokeRequired,
      }
    },
    [chainId, address, estimate, checkAllowanceERC20],
  )
}
